import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ReactPlayer from "react-player";
import Close from "../common/Close";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    position: "absolute",
    top: 94,
    bottom: 0,
  },
  container: {
    top: 40,
    bottom: 0,
    overflow: "scroll",
    position: "absolute",
    width: "100%",
    paddingTop: 12,
    paddingLeft: 15,
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(0,0,0,.4) #eeeeee95",
    "&::-webkit-scrollbar": {
      width: "0.45em",
    },
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.4)",
      outline: "1px solid slategrey",
    },
  },
  heading: {
    borderBottom: "1px solid #f1ecec",
    display: "flex",
    width: "100%",
    height: "2.75em",
    paddingLeft: 15,
  },
  language: {
    fontSize: "1.1rem",
    textTransform: "capitalize",
  },
  menuRoot: {
    border: "1px solid #dddddd",
    boxShadow: "none",
    "&$expanded": {
      margin: 0,
    },
  },
  expanded: {},
  expansionDetails: {
    boxShadow: "none",
    padding: "0 0 0 20px",
    width: "100%",
  },
  summaryPanel: {
    textTransform: "capitalize",
    borderBottom: "1px solid #b7b7b785",
    backgroundColor: "#efefef",
    "&$expanded": {
      minHeight: 50,
    },
  },
  content: {
    margin: "10px 0",
    "&$expanded": {
      margin: "12px 0",
    },
  },
  audioBible: {
    display: "block",
    paddingLeft: 0,
    fontSize: "1rem",
  },
  player: {
    marginTop: 5,
    "& audio": {
      outlineWidth: 0,
    },
  },
  closeButton: {
    marginRight: 15,
    marginTop: -6,
  },
  subContainer: {
    paddingRight: 4,
  },
}));
const Audio = (props) => {
  const classes = useStyles();
  const [message, setMessage] = React.useState("");
  let { audioBible, bookCode, chapter, book } = props;
  const [playing, setPlaying] = React.useState("");

  const getBook = (code) => {
    return book[code][book[code].findIndex((x) => x.book_code === bookCode)]
      .short;
  };
  React.useEffect(() => {
    if (audioBible.length === 0 || audioBible.success === false) {
      setMessage("No audio bibles available");
    } else {
      let index = audioBible.findIndex((language) => {
        let bookIndex = language.audioBibles.findIndex((a) =>
          a.books.hasOwnProperty(bookCode)
        );
        return bookIndex !== -1;
      });
      if (index === -1) {
        setMessage("No audio bibles available for this book");
      } else {
        setMessage("");
      }
    }
  }, [audioBible, bookCode]);
  return (
    <div className={classes.root}>
      <Box className={classes.heading}>
        <Box flexGrow={1}>
          <Typography variant="h6">Audio Bibles</Typography>
        </Box>
        <Box>
          <Close className={classes.closeButton} />
        </Box>
      </Box>

      <div className={classes.container}>
        {message || audioBible.success === false || (
          <div className={classes.subContainer}>
            {audioBible.map((language, i) => {
              //Assume that the whole book is there, not searching for chapter
              let bookIndex = language.audioBibles.findIndex((a) =>
                a.books.hasOwnProperty(bookCode)
              );
              return bookIndex === -1 ? (
                ""
              ) : (
                <Accordion
                  defaultExpanded={true}
                  classes={{
                    root: classes.menuRoot,
                    expanded: classes.expanded,
                  }}
                  key={i}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    classes={{
                      root: classes.summaryPanel,
                      expanded: classes.expanded,
                      content: classes.content,
                    }}
                  >
                    <Typography className={classes.language}>
                      {language.language.name +
                        " " +
                        getBook(language.language.code) +
                        " " +
                        chapter}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ padding: 0 }}>
                    <List className={classes.expansionDetails}>
                      {language.audioBibles.map((audio, i) => {
                        let url =
                          audio.url +
                          bookCode +
                          "/" +
                          chapter +
                          "." +
                          audio.format;
                        let id = language.language.code + i;
                        return audio.books.hasOwnProperty(bookCode) ? (
                          <ListItem
                            key={i}
                            value={audio.name}
                            className={classes.audioBible}
                          >
                            {audio.name}
                            <ReactPlayer
                              key={i}
                              playing={playing === id}
                              url={url}
                              onPlay={() => setPlaying(id)}
                              controls
                              width="100%"
                              height="50px"
                              className={classes.player}
                              config={{
                                file: {
                                  attributes: {
                                    controlsList: "nodownload",
                                  },
                                },
                              }}
                            />
                          </ListItem>
                        ) : (
                          ""
                        );
                      })}
                    </List>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
export default Audio;
